import { Box, Typography } from "@mui/material"
import { LineChart } from "../Charts/Line"
import { Card } from "./Card"
import { ToggableCard } from "./ToggableCard"
import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { getTotalAccessPerMonthReport } from "src/service/dashboardService"
import { useGlobalSelectedCompany } from "src/context/GlobalSelectedCompanyContext"

type TotalAccessPerMonthReportData = Array<{
  companyId: string
  companyName: string
  totalAccess: Record<string, number>
}>

export const TotalAccessPerMonth = () => {
  const { t } = useTranslation()
  const [reportData, setReportData] = useState<TotalAccessPerMonthReportData>([])
  const { selectedCompanyId, isGlobalAdminSelected } = useGlobalSelectedCompany()


  const getData = async () => {
    const paramsCompanyId = isGlobalAdminSelected() ? {} : { companyId : selectedCompanyId }
    const content = await getTotalAccessPerMonthReport({ params: { ...paramsCompanyId }})
    setReportData(content)
  }

  useEffect(() => {
    getData()
  }, [selectedCompanyId])

  return (
    <ToggableCard viewkey="users">
      <Card
        sx={{
          display: 'flex',
          py: '8px',
          px: '32px',
        }}
      >
        <Box
          sx={{
            width: '870px',
            height: '270px',
            pt: '8px',
            px: '32px',
            pb: '36px'
          }}
        >
          <Typography
            sx={{
              fontSize: '14px',
              color: 'rgba(0, 0, 0, 0.6);',
              whiteSpace: 'pre-wrap',
              mb: 2,
            }}
          >
            {t('painel.totalaccesspermonth')}
          </Typography>
          <LineChart data={reportData} />
        </Box>
      </Card>
    </ToggableCard>
  )
}
